import {combineValidators, required, maxLength, isPrice} from "../Validators";

export const EditMenuItemScheme = {
  name: required,
  description: combineValidators(required, maxLength(500)),
  price: combineValidators(required, isPrice),
};